import type { ReactNode } from 'react';
import React from 'react';
import { useStyletron } from 'baseui';
import type { OnChangeParams } from 'baseui/select';
import { Select, SIZE } from 'baseui/select';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { ParagraphSmall } from 'baseui/typography';
import type { StyleObject } from 'styletron-react';
import { SectionWrapper } from './section-wrapper';
type Option = {
  label: string;
  value: string;
  startEnhancer: ReactNode;
  additionalInfo?: string;
};
interface LabelModificationProps {
  options: Option[];
  currentValue: string;
  onChange: (value: string) => void;
  header?: ReactNode;
  wrapperStyles?: StyleObject;
  wrapperTitleColor?: string;
}
export const LabelModificationSelector = ({
  options,
  currentValue,
  onChange,
  header,
  wrapperStyles = {},
  wrapperTitleColor
}: LabelModificationProps) => {
  const [css, theme] = useStyletron();
  const currentSelectedValue = options.find(option => option.value === currentValue);
  const handleChange = (params: OnChangeParams) => {
    onChange(params.value[0]?.value);
  };
  const getModifiedComponent = (component: ReactNode, additionalInfo: string) => {
    if (!additionalInfo) {
      return component;
    }
    return <StatefulTooltip content={() => <div>{additionalInfo}</div>} placement={PLACEMENT.left} returnFocus autoFocus ignoreBoundary={true} showArrow={true}>
        {component}
      </StatefulTooltip>;
  };
  const getOptionAndLabelComponent = ({
    option
  }) => {
    return getModifiedComponent(<div className={css({
      display: 'flex',
      alignItems: 'center',
      gap: theme.sizing.scale400
    })}>
        <span className={css({
        display: 'flex',
        alignItems: 'center'
      })}>
          {option.startEnhancer}
        </span>
        <ParagraphSmall margin={0} padding={0}>
          {option.label}
        </ParagraphSmall>
      </div>, option.additionalInfo || '');
  };
  return <SectionWrapper title={header} wrapperTitleColor={wrapperTitleColor} style={wrapperStyles}>
      <Select options={options} onChange={handleChange} value={currentSelectedValue ? [currentSelectedValue] : undefined} size={SIZE.compact} clearable={false} labelKey="label" valueKey="value" getOptionLabel={getOptionAndLabelComponent} getValueLabel={getOptionAndLabelComponent} />
    </SectionWrapper>;
};